module.exports = __webpack_public_path__ + "static/media/1557185301607.4c8a1587.jpg";